module.exports = __webpack_public_path__ + "img/hero-image-non-logged-no.77534ada.png";